var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-tree"},[_c('div',{staticClass:"fm-tree-disk sticky-top"},[_c('i',{staticClass:"far fa-hdd"}),_vm._v(" "+_vm._s(_vm.selectedDisk)+"\n  ")]),_vm._v(" "),_c('branch',{attrs:{"parent-id":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }